
export default function Partners() {
  const partnerTypes = [
    {
      name: 'Publishers',
      category: 'Content Providers',
      description: 'Direct partnerships with book and media publishers',
      color: 'bg-akten',
    },
    {
      name: 'Wholesalers',
      category: 'Wholesale Suppliers',
      description: 'Reliable wholesalers for high-volume product sourcing',
      color: 'bg-akten',
    },
    {
      name: 'Distributors',
      category: 'Logistics Partners',
      description: 'National and regional distribution networks',
      color: 'bg-akten',
    },
    {
      name: 'Authorized Suppliers',
      category: 'Approved Sources',
      description: 'Brand-approved and certified suppliers',
      color: 'bg-akten',
    },
    {
      name: 'Manufacturers',
      category: 'Direct Source',
      description: 'Direct manufacturer relationships in select product categories',
      color: 'bg-akten',
    },
    {
      name: 'Brand Owners',
      category: 'Strategic Partners',
      description: 'Exclusive agreements and long-term collaborations',
      color: 'bg-akten',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="inline-block bg-gray-900 text-white px-6 py-2 rounded-full text-sm font-medium mb-6">
            WHO WE WORK WITH
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 max-w-3xl leading-tight">
            We Only Work With
            <br />
            Authorized Supply Chains
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {partnerTypes.map((partner, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow border border-gray-200"
            >
              <div className="flex items-start space-x-4 mb-4">
                <div className={`w-14 h-14 rounded-full ${partner.color} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white font-bold text-lg">
                    {partner.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {partner.name}
                  </h3>
                  <p className="text-sm text-gray-500">{partner.category}</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                "{partner.description}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
